import { VITE_USE_MOCK, VITE_MOCK_API, VITE_IMAGE_MATCHER_API } from 'Constants/appEnvConstants'

export default function getImageMatcherBaseUrl() {
  // eslint-disable-next-line no-undef
  return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_IMAGE_MATCHER_API;
}
